import { Types, Utils } from "@grandvisionhq/auth";
const toSavedOptIns = (rawOptIns) => {
  if (!rawOptIns) {
    return {};
  }
  return rawOptIns.reduce(
    (result, optIn) => ({
      ...result,
      [optIn.id]: optIn.value ?? false
    }),
    {}
  );
};
const getShownOptIns = (allOptIns, savedOptIns) => {
  if (!Object.keys(savedOptIns).length) {
    return allOptIns;
  }
  const alreadySelectedOptIns = Object.keys(savedOptIns).filter((key) => savedOptIns[key]);
  return allOptIns.filter((optIn) => {
    if (!Types.isGroupedOptin(optIn)) {
      return !alreadySelectedOptIns.includes(optIn.value);
    }
    const ungroupedOptIns = Utils.ungroupOptIns([optIn]);
    return ungroupedOptIns.some((o) => !alreadySelectedOptIns.includes(o.value));
  });
};
const createOptIn = (optIn, checked, getLabel) => {
  return {
    [optIn.value]: {
      label: getLabel(optIn.titleKey) || optIn.value,
      checked
    }
  };
};
const toChangedOptIns = (optIns, savedOptIns, selectedOptIns, getLabel) => {
  const ungroupOptIn = (optIn, isSelected) => {
    return Utils.ungroupOptIns([optIn]).filter((optIn2) => {
      const isPreviouslySaved = Object.keys(savedOptIns).includes(optIn2.value);
      if (isPreviouslySaved && savedOptIns[optIn2.value] === true && isSelected === false) {
        return false;
      }
      return savedOptIns[optIn2.value] !== isSelected;
    }).map((optIn2) => {
      const isChecked = isSelected || savedOptIns[optIn2.value] || false;
      return createOptIn(optIn2, isChecked, getLabel);
    }).reduce((prev, curr) => ({ ...prev, ...curr }), {});
  };
  const toChangedOptIn = (optIn) => {
    const isSelected = Boolean(selectedOptIns.find((o) => o.titleKey === optIn.titleKey));
    if (Types.isGroupedOptin(optIn)) {
      return ungroupOptIn(optIn, isSelected);
    }
    const shownOptIns = getShownOptIns(optIns, savedOptIns);
    const isHidden = !Boolean(shownOptIns.find((s) => s.titleKey === optIn.titleKey));
    if (isHidden) {
      return;
    }
    const isPreviouslySaved = Object.keys(savedOptIns).includes(optIn.value);
    const changedFromPreviouslySaved = savedOptIns[optIn.value] !== isSelected;
    if (isPreviouslySaved && !changedFromPreviouslySaved) {
      return;
    }
    const isChecked = isSelected || savedOptIns[optIn.value] || false;
    return createOptIn(optIn, isChecked, getLabel);
  };
  return optIns.reduce((result, optIn) => {
    return {
      ...result,
      ...toChangedOptIn(optIn)
    };
  }, {});
};
export {
  getShownOptIns,
  toChangedOptIns,
  toSavedOptIns
};
//# sourceMappingURL=opt-ins.js.map
